import React, { useEffect } from 'react';
import DigitalBanner from './DigitalBanner';
import Ditalcards from './Ditalcards';
import Testimonialcards from './Testimonialcards';
import Digitalpagesection from './Digitalpagesection';
import Digitalcapabilityhovercards from './Digitalcapabilityhovercards';
import Digitalengineeringpage from './Digitalengineeringpage';
import DigitalSectionthree from './DigitalSectionthree';
import DigitalmobilityTabscards from './DigitalmobilityTabscards';
import Digitalimpactdeliverypage from './Digitalimpactdeliverypage';



const DigitalPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
          // Scroll to the top of the page when the component mounts
 
  return (
    <div style={{background:'#fff'}}>
        <DigitalBanner />
        <Digitalpagesection />

        <Ditalcards />
        <Digitalcapabilityhovercards />
        <DigitalSectionthree />
        <Digitalimpactdeliverypage />
        <DigitalmobilityTabscards />
        {/* <Digitalengineeringpage /> */}
        {/* <Testimonialcards /> */}


        <style>
          {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
        </style>
    </div>
  )
}

export default DigitalPage;